import Flex from '@/components/priority/Flex/Flex'
import Text from '@/components/priority/Text/Text'
import type { SkippedTemplate } from '@/api/admin'

type LaunchCopyOutcomeProps = {
  refusal: string | null
  skipped: SkippedTemplate[]
}

/** What a Launch copy refused, or the templates it left out, shown in its
 * modal so the admin sees them before closing it. */
export const LaunchCopyOutcome = ({
  refusal,
  skipped,
}: LaunchCopyOutcomeProps) => (
  <>
    {refusal && (
      <Text margin="0 0 12px 0" color="red" data-testid="launch-copy-refusal">
        {refusal}
      </Text>
    )}
    {skipped.length > 0 && (
      <Flex column margin="0 0 12px 0" data-testid="launch-copy-skipped">
        <Text margin="0 0 6px 0" color="orange" weight="600">
          These layouts were not copied, because the Lotus text boxes they hold
          cannot be placed where the copy writes:
        </Text>
        {skipped.map((template) => (
          <Text key={template.id} data-testid="launch-copy-skipped-template">
            {template.name}
          </Text>
        ))}
      </Flex>
    )}
  </>
)
